<template>
	<div v-if="active" class="modalContainer">
		<div
			v-bind:class="{ modal: true, autoHeight: heigth == 'auto' }"
			v-bind:style="{ heigth: heigth }"
			id="modalContent"
		>
			<div v-on:click="close" class="close">
				<i class="fa fa-times"></i>
			</div>
			<modal-save v-if="currentModal == 'save'"></modal-save>
			<modal-added-to-cart
				v-if="currentModal == 'addedToCart'"
			></modal-added-to-cart>
			<modal-message
				:message-data="modalData"
				v-if="currentModal == 'message'"
			></modal-message>
			<modal-share v-if="currentModal == 'share'"></modal-share>
			<modal-no-stock v-if="currentModal == 'noStock'"></modal-no-stock>
		</div>
		<!-- flexslider-->

		<div v-on:click="close" class="modalBG"></div>
	</div>
</template>

<script>
import ModalAddedToCart from 'components/Modals/Content/AddedToCart'
import ModalSave from 'components/Modals/Content/Save'
import ModalMessage from 'components/Modals/Content/Message'
import ModalShare from 'components/Modals/Content/Share'
import ModalNoStock from 'components/Modals/Content/NoStock'

export default {

  components: {
    ModalAddedToCart,
    ModalSave,
    ModalMessage,
    ModalShare,
    ModalNoStock
  },

  data: function(){
    return{
    	currentModal: false,
    	active: false,
    	heigth: "auto",
    	modalData: "",
    }
  },

  methods: {

  	open: function(data){

      var self = this;

  		this.currentModal = data.modal

  		if(data.heigth){
  			this.heigth = data.heigth
  		}

  		if(data.data){
  			this.modalData = data.data;
  		}

  		this.active = true;


      // Set dynamic height
      window.vueRender(function(){

        $("#modalContent img").bind("onload", function() {
            self.setHeight()
        });

        self.setHeight()

      })
  	},

    setHeight(){
      if($(window).width() > 812){
        var modalContent = $("#modalContent")
        var height = modalContent.innerHeight() + 100
        var marginTop = ($(window).height()) / 2 - (height / 2);
        modalContent.css("margin-top", marginTop)
      }

    },

  	reset: function(){
  		this.heigth = "auto";
  		this.active = false;
  	},

  	close: function(){
  		this.active = false;
       $("#brim-treadmill").show();
  	}

  },

  mounted: function () {

   	var self = this;

   	window.eventHub.$on('openModal', function (data) {
   		self.reset();
   		self.open(data);
  	});

  	window.eventHub.$on('closeModal', function (data) {
   		self.reset();
   		self.close();
  	});

  }

}
</script>

<style>
	.modalContainer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999999;

		.title {
			font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
			text-align: center;
			padding: 0px 0px 5px 0px;
			font-size: 20px;
			text-transform: uppercase;
			font-weight: 500;
			border-bottom: 1px solid rgba(0, 0, 0, 0.12);
			max-width: 80%;
			margin: auto;
		}

		.modalBG {
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 0.72);
			position: fixed;
			z-index: 9999999;
			top: 0;
			left: 0;
		}

		.modal {
			position: fixed;
			padding: 15px;
			width: 675px;
			left: 50%;
			margin-left: -337.5px;
			background: white;
			border: 1px solid rgba(0, 0, 0, 0.29);
			z-index: 99999999;

			&.autoHeight {
				padding-bottom: 70px;
			}

			/* Tablet */
			@media screen and (max-width: 1024px) {
				width: 620px;
				left: 50%;
				margin-left: -310px;
			}

			/* Mobile */
			@media screen and (max-width: 812px) {
				width: 100% !important;
				left: 0;
				margin: 0 !important;
				top: 0;
				height: 100%;
				padding-bottom: 15px;
				position: fixed;
			}
		}

		.close {
			position: absolute;
			right: 0px;
			top: 0px;
			padding: 9px 15px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// Modal.vue?1b279409